import StateRun from './types'

const state = {
  featureMode: 'none',
  registeredAsNewUser: false
} as StateRun

export default state
